import {LANGUAGES_BY_BASENAME} from "../../constants/languages";
import ClientLocaleInterceptor from "../interceptors/clientLocaleInterceptor";
import {newsApiParams} from "../../../config";
import API from "..";

export const configureApi = ({lang}) => {
  const locale = LANGUAGES_BY_BASENAME[lang === "en" ? "" : lang].key;

  ClientLocaleInterceptor.setLocale(locale);

  API.News.updateConfig({
    baseURL: `${newsApiParams.baseUrl}/${locale}`,
  });
};
